/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBox: {
  name: 'box';
  data: string;
} = {
  name: 'box',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 2 5.236V19a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8.236C3.386 7.686 3 6.888 3 6Zm3 3h12v10H6V9Zm0-4a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2H6Zm4 7a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z" fill="currentColor"/></svg>`,
};
